import { IGoogleMap, ILatLng } from 'src/app/core/models/google-map-models';
import { AALocationModel, RoutePlannerDataModel } from '../../route-planner/models/route-model';
import { GoogleMapType } from '../enums/google-map-enum';
import { GoogleMapsAPIWrapperService } from '../services/google-map-wrapper/google-maps-api-wrapper.service';
import { GoogleMapGeoService } from '../../aa-core/services/google/aa-google-geo/google-map-geo.service';
import { AAGoogleIconService } from '../../aa-core/services/google/aa-google-icon/aagoogle-icon.service';
import { GoogleMapEvents, AAGoogleMapEvents } from 'src/app/core/events/events';
import { GoogleMapBase } from './google-map-base';
import { IHybridGoogleMap } from './interface/hybrid-google-map-interface';
import { GoogleMapRouteService } from '../services/google-map-route/google-map-route.service';
import { RoutePlannerLocalStoreService } from '../../aa-core/services/route-planner-local-store/route-planner-local-store.service';
import { GoogleCacheManagerService } from '../services/google-cache-manager/google-cache-manager.service';

export class HybridGoogleMap extends GoogleMapBase implements IHybridGoogleMap {
  public routeDataModel: RoutePlannerDataModel;
  public googleMapGeoUtils: GoogleMapGeoService;
  public googleIconService: AAGoogleIconService;
  public mapsWrapper: GoogleMapsAPIWrapperService;
  public googleMapRouteService: GoogleMapRouteService;
  public routePlannerLocalStore: RoutePlannerLocalStoreService;
  public googleMapCacheManager: GoogleCacheManagerService;

  public directionsService;
  public directionsDisplay;
  public routeDirectionMarker: Array<any> = [];
  public gReqOptions: any;

  private mapData: any;
  private routeOverlay: any;
  private readonly stokeColor: string = '#1685F4';

  constructor(mapType: GoogleMapType) {
    super(mapType);
    this.on(AAGoogleMapEvents.UPDATE_MAP, this.updateMapEvent.bind(this));
    this.on(AAGoogleMapEvents.RESET_MAP, this.resetMap.bind(this));
  }

  public destroy(): void {
    super.destroy();
    this.remove(AAGoogleMapEvents.UPDATE_MAP, this.updateMapEvent);
    this.remove(AAGoogleMapEvents.RESET_MAP, this.resetMap);
  }

  public updateMapEvent (mapType?: GoogleMapType) {
    if (this.validateThisMap(mapType)) {
      this.updateMapData(null);
    }
  }

  public resetMap(mapType?: GoogleMapType) { }

  public setDependency(googleMapGeoUtils: GoogleMapGeoService, googleIconService: AAGoogleIconService,
    mapsWrapper: GoogleMapsAPIWrapperService, googleMapRouteService: GoogleMapRouteService,
    routePlannerLocalStore: RoutePlannerLocalStoreService, googleMapCacheManager: GoogleCacheManagerService) {
      this.googleMapGeoUtils = googleMapGeoUtils;
      this.googleIconService = googleIconService;
      this.mapsWrapper = mapsWrapper;
      this.googleMapRouteService = googleMapRouteService;
      this.routePlannerLocalStore = routePlannerLocalStore;
      this.googleMapCacheManager = googleMapCacheManager;
  }

  public setGoogleMap(googleMap: IGoogleMap): void {
    this.googleMap = googleMap;
  }

  // public loadMap(nativeElement, config):void {
  //   this.mapsWrapper.createMap(nativeElement, config).then(this.loadMapHandler);
  // }

  // private loadMapHandler = (googleMap: GoogleMap) => {
  //   this.googleMap = googleMap;
  //   console.log('Map Loaded:', this.mapType);
  //   this.dispatch(HybridMapEvents.MAP_READY, googleMap);
  // }

  public initMap(routeDataModel: RoutePlannerDataModel) {
    this.routeDataModel = routeDataModel;

    // init
    this.directionsService = new google.maps.DirectionsService();
    this.directionsDisplay = new google.maps.DirectionsRenderer({
      suppressMarkers: true
    });

    this.directionsDisplay.setMap(this.googleMap);
    // this.setRouteDirection();
    this.addGoogleMapEvent(this.googleMap);
  }

  public addGoogleMapEvent(googleMap: IGoogleMap): void {
    google.maps.event.addListener(googleMap, GoogleMapEvents.DRAG_END, () => {
      this.dispatch(GoogleMapEvents.DRAG_END, this.mapType);
      this.invalidateCluster();
    });

    google.maps.event.addListener(googleMap, GoogleMapEvents.ZOOM_CHANGED, () => {
      this.dispatch(GoogleMapEvents.ZOOM_CHANGED, this.mapType);
      this.invalidateCluster();
    });

    google.maps.event.addListener(googleMap, GoogleMapEvents.BOUNDS_CHANGED, () => {
      this.dispatch(GoogleMapEvents.BOUNDS_CHANGED, this.mapType);
    });

    google.maps.event.addListener(googleMap, GoogleMapEvents.RIGHT_CLICK, (event) => {
      const latLng: ILatLng = {lat: event.latLng.lat(), lng: event.latLng.lng()};
      this.dispatch(AAGoogleMapEvents.MOUSE_CLICKED, latLng);
    });
  }

  public invalidateCluster(): void { }

  public updateMapData(data) {
    if (this.mapType !== GoogleMapType.TRAFFIC_NEWS && this.mapType !== GoogleMapType.MAPS) {
      this.setRouteDirection(data);
    }
  }

  public setRouteDirection(data): any {
    this.mapData = data;
    this.gReqOptions = this.getGoogleDirectionServiceOptions();

    if (this.routeDataModel.OptionsData.AvoidTraffic) {
      this.gReqOptions = Object.assign( { drivingOptions: { departureTime: new Date() } }, this.gReqOptions );
    }

    const options = this.googleMapCacheManager.validateDirectionRequest({request: this.gReqOptions, responce: null});
    // console.log('Direction Already Existing....::', options);

    if (options && options.responce) {
      this.directionsServiceRequestHandler( options.responce, google.maps.GeocoderStatus.OK, true);
    } else {
      setTimeout(() => {
        this.directionsService.route(this.gReqOptions, this.directionsServiceRequestHandler.bind(this));
      }, 100);
    }

    return this.gReqOptions;
  }

  public directionsServiceRequestHandler(response, status, exist?: boolean) {
    // console.log('hyprid on ===> directionsService', this.mapType, response, this.routeDataModel);

    if (!exist) {
      this.googleMapCacheManager.validateDirectionRequest({request: this.gReqOptions, responce: response});
    }

    if (status === google.maps.GeocoderStatus.OK) {
      this.directionsDisplay.setMap(this.googleMap);
      // this.directionsDisplay.setDirections(response);

      const routes: any = this.sortRouteByDuration(response.routes);

      const selectedRoute = routes[ this.routeDataModel.SummaryData.SelectedAltRoute ];
      const googleRoute = this.mapsWrapper.reformatGoogleRouteResponse( new Array(selectedRoute));

      this.renderAARoutePath(googleRoute);
      this.addRouteDirectionMarkers(false);

      const bounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(
          googleRoute.routes[0].bounds.southwest.lat,
          googleRoute.routes[0].bounds.southwest.lng
        ),
        new google.maps.LatLng(
          googleRoute.routes[0].bounds.northeast.lat,
          googleRoute.routes[0].bounds.northeast.lng
        )
      );

      // setTimeout( () => {
        if (this.mapData && this.mapData.Direction) {
          this.setMapToCenter(this.googleMap, this.mapData.Direction.location, 15);
          this.googleMapRouteService.addDecodedRoundRouteOverlay(this.googleMap, this.mapData.Direction);
        } else {
          this.googleMap.fitBounds(bounds);
        }
      // }, 10);

    } else if (status === google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
      //
    } else {
      console.log('Directions request failed due to ' + status);
    }
  }

  public addRouteDirectionMarkers(draggable: boolean) {
    this.googleMapRouteService.clearDirectionMaker(this.routeDirectionMarker);
    this.routeDirectionMarker = this.googleMapRouteService.updateDirectionMarker(this.googleMap, this.routeDataModel, draggable);
  }

  public addTrafficLayer() {
    const trafficLayer = new google.maps.TrafficLayer();
          trafficLayer.setMap(this.googleMap);
  }

  public getGoogleDirectionServiceOptions(): any {
    if (this.routeDataModel.FromLocation.valid() && this.routeDataModel.ToLocation.valid()) {
      return {
        origin: this.routeDataModel.FromLocation.latLng,
        destination: this.routeDataModel.ToLocation.latLng,
        travelMode: google.maps.DirectionsTravelMode.DRIVING,
        unitSystem: google.maps.DirectionsUnitSystem.IMPERIAL,
        waypoints: this.getWaypoints(),
        optimizeWaypoints: false,
        avoidHighways: this.routeDataModel.OptionsData.AvoidHighways,
        avoidTolls: this.routeDataModel.OptionsData.AvoidTolls,
        provideRouteAlternatives: true
      };
    } else {
      return null;
    }
  }

  public getWaypoints(): Array<any> {
    const waypoints: Array<any> = [];
    const rawWayPoints = this.routeDataModel.ViaRoutes ? this.routeDataModel.ViaRoutes : [];

    for (let wpCounter = 0; wpCounter < rawWayPoints.length; wpCounter++) {
      const wayPoint: AALocationModel = rawWayPoints[wpCounter];
      if (wayPoint.valid() ) {
        const obj = { stopover: true, location: rawWayPoints[wpCounter].latLng };
        waypoints.push(obj);
      }
    }
    return waypoints;
  }

  public renderAARoutePath = currentRouteData => {
    const polyPath = this.createPolyLinePath(currentRouteData.routes[0]);

    // display polyline
    this.addDecodedRouteOverlay(polyPath);
  }

  private createPolyLinePath(currentRouteData) {
    let polyPath = [], groute: any = {};

    // Loop through each route in the GDirections object
    for (let i = 0; i < currentRouteData.legs.length; i++) {
      groute = currentRouteData.legs[i];

      // Loop through all the steps in the route
      for (let j = 0; j < groute.steps.length; j++) {
        const gstep = groute.steps[j];
        if ( gstep.hasOwnProperty('polyline') &&  gstep.polyline !== null &&
             gstep.polyline.hasOwnProperty('points') && gstep.polyline.points !== null ) {
          polyPath = polyPath.concat( this.googleMapGeoUtils.decode(gstep.polyline.points) );
        }
      }
    }

    return polyPath;
  }

  private addDecodedRouteOverlay = decPoints => {
    const polyOptions = {
      strokeColor: this.stokeColor,
      strokeWeight: 10,
      clickable: false,
      strokeOpacity: 0.7,
      path: decPoints
    };

    if (!this.routeOverlay) {
      this.routeOverlay = new google.maps.Polyline(polyOptions);
    } else {
      this.routeOverlay.setOptions(polyOptions);
    }
    this.routeOverlay.setMap(this.googleMap);
  }

  setMapToCenter(googleMap: IGoogleMap, latLng: ILatLng, zoomLevel?: number) {
    if (zoomLevel && zoomLevel !== googleMap.getZoom()) {
      googleMap.setZoom(zoomLevel || googleMap.getZoom());
    }
    googleMap.setCenter(latLng);
  }

}
